import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import { useSelector } from "react-redux";

export default function DefineQuotaTable() {
   const define = useSelector((state) => state.define);
   const { showChart, quotaTableData } = define;

   const { rows, cols } = quotaTableData;

   return (
      <Box sx={{ display: showChart ? "none" : "block" }}>
         <DataGrid
            disableColumnMenu
            sx={{ maxHeight: "50vh", "& .MuiDataGrid-cell": { border: "1px solid #000" } }}
            rows={rows}
            columns={cols}
         ></DataGrid>
      </Box>
   );
}
